import GetAllRecords from './GetAllRecords';
import GetScreensFoCurrentDso from './GetScreensForCurrentDSO';
import GetScreensWithZones from './GetAllScreensWithZone';
import StepsMangment from './CreateNewDisplay';
import InviteToDisplays from './InviteToDisplay';
import GetLocations from './GetLocations';
import CreateLocation from './CreateLocation';
import GetAllLocations from './GetAllLocations';
import UploadDisplayFile from './UploadDisplayFile';
import UploadLocationFile from './UploadLocationFile';
import CreateRateSchedule from './CreateRateSchedule';
import GetRateSchedules from './GetRateSchedules';
import GetAllRateSchedules from './GetAllRateSchedules';
import DisplaysWithoutSchedules from './DisplaysWithoutSchedules';
import DeleteRateSchedule from './DeleteRateSchedule';
import AssignRateSchedule from './AssignRateSchedule';
import DeleteLocation from './DeleteLocation';
import GetAdvDisplaysLookup from './GetAdvDisplaysLookup';
import GetDisplayCampaignCount from './GetDisplayCampaignCount';
import GetLocationById from './GetLocationById';
import UpdateLocation from './UpdateLocation';
import ToggleFavouriteDisplays from './ToggleFavouriteDisplays';
import EditDisplay from './EditDisplay';
import ProgressStepDSO from './ProgressDSO';
import GetDisplayById from './GetDisplayById';
import GetRateScheduleById from './GetRateScheduleById';
import LocationsBulkUpload from './LocationsBulkUpload';
import DisplayBulkUpload from './DisplaysBulkUpload';
import LayoutConfigurations from './LayoutConfigurations';
import BulkUpdateDisplays from './BulkUpdateDisplays';
import BulkDeleteDisplays from './BulkDeleteDisplays';
import AdminDisplayLifecycle from './AdminDisplayLifecycle';
const displays = {
  getAllDisplays: GetAllRecords,
  stepsSlice: StepsMangment,
  getScreentForDso: GetScreensFoCurrentDso,
  getScreensWithZones: GetScreensWithZones,
  inviteToDisplays: InviteToDisplays,
  getLocations: GetLocations,
  createLocation: CreateLocation,
  getAllLocations: GetAllLocations,
  uploadDisplayFile: UploadDisplayFile,
  uploadLocationFile: UploadLocationFile,
  createRateSchedule: CreateRateSchedule,
  getRateSchedules: GetRateSchedules,
  getAllRateSchedules: GetAllRateSchedules,
  displaysWithoutSchedules: DisplaysWithoutSchedules,
  deleteRateSchedule: DeleteRateSchedule,
  assignRateSchedule: AssignRateSchedule,
  deleteLocation: DeleteLocation,
  getAdvDisplaysLookup: GetAdvDisplaysLookup,
  getDisplayCampaignCount: GetDisplayCampaignCount,
  getLocationById: GetLocationById,
  updateLocation: UpdateLocation,
  ToggleFavouriteDisplays: ToggleFavouriteDisplays,
  editDisplay: EditDisplay,
  progressStepDSO: ProgressStepDSO,
  GetDisplayById: GetDisplayById,
  GetRateScheduleById: GetRateScheduleById,
  locationsBulkUpload: LocationsBulkUpload,
  displayBulkUpload: DisplayBulkUpload,
  layoutConfigurations: LayoutConfigurations,
  bulkUpdateDisplays: BulkUpdateDisplays,
  bulkDeleteDisplays: BulkDeleteDisplays,
  adminDisplayLifecycle: AdminDisplayLifecycle,
};

export default displays;
